import { render, staticRenderFns } from "./GroupParty.vue?vue&type=template&id=053e5a22&lang=pug"
import script from "./GroupParty.vue?vue&type=script&lang=js"
export * from "./GroupParty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports